export default "__VITE_ASSET__DFYHqnNg__"